import { createAsyncComponent, withInstall } from '@mts-fe/utils';
import appLocalePicker from './src/AppLocalePicker.vue';
import appLogo from './src/AppLogo.vue';

export const AppLogo = withInstall(appLogo);
export const AppLocalePicker = withInstall(appLocalePicker);
export const AppSearch = createAsyncComponent(() => import('./src/search/AppSearch.vue'));
export const AppTenantPicker = createAsyncComponent(() => import('./src/AppTenantPicker.vue'));
export const AppDevPanel = createAsyncComponent(() => import('./src/AppDevPanel.vue'));
